var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "hamburger hamburger--elastic",
      class: { "is-active": _vm.isOpen },
      attrs: {
        "aria-label": "Menu",
        "aria-expanded": _vm.isOpen ? "true" : "false"
      },
      on: { click: _vm.toggle }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "hamburger-box" }, [
      _c("span", { staticClass: "hamburger-inner" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21a0f058", { render: render, staticRenderFns: staticRenderFns })
  }
}